export function findShortestPath(target, maxDepth = 15) {
    const ADD_COINS = [1, 2, 5, 10];
    const MULTS = [5, 4, 3, 2];
    const DIV = 2;
    if (target === 1) {
        return [];
    }
    const queue: any = [
        {
            value: 1,
            path: [],
        },
    ];
    const visited = new Set([Math.round(1 * 100) / 100]);
    let closestValue = 1;
    let closestPath = [];
    let minDistance = Math.abs(1 - target);

    while (queue.length > 0) {
        const { value, path } = queue.shift();
        if (path.length >= maxDepth) {
            console.warn(`Search depth limit of ${maxDepth} reached. Returning the closest path found so far.`);
            return closestPath;
        }
        const processNextState = (nextValue, nextPath) => {
            const roundedValue = Math.round(nextValue * 100) / 100;
            if (Math.abs(roundedValue - target) < 1e-9) {
                return nextPath;
            }
            const distance = Math.abs(roundedValue - target);
            if (distance < minDistance) {
                minDistance = distance;
                closestValue = roundedValue;
                closestPath = nextPath;
            }
            if (roundedValue > 0 && !visited.has(roundedValue)) {
                visited.add(roundedValue);
                queue.push({
                    value: roundedValue,
                    path: nextPath,
                });
            }
            return null;
        };
        for (const add of ADD_COINS) {
            const nextValue = value + add;
            const nextPath = [
                ...path,
                {
                    function: 'add',
                    value: add,
                },
            ];

            const result = processNextState(nextValue, nextPath);
            if (result) return result;
        }
        for (const mult of MULTS) {
            const nextValue = value * mult;
            const nextPath = [
                ...path,
                {
                    function: 'multiply',
                    value: mult,
                },
            ];
            if (nextValue <= target + minDistance) {
                const result = processNextState(nextValue, nextPath);
                if (result) return result;
            }
        }
        const nextValue = value / DIV;
        const nextPath = [
            ...path,
            {
                function: 'divide',
                value: DIV,
            },
        ];

        const result = processNextState(nextValue, nextPath);
        if (result) return result;
    }
    console.log(`Exact target not found. Returning closest path to value: ${closestValue}`);
    return closestPath;
}

export function generateRandomTarget(min = 0.1, max = 1000) {
    const randomValue = Math.random() * (max - min) + min;
    return Math.round(randomValue * 100) / 100;
}
